import React, { useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import { ReactComponent as CheckBoxIcon } from "../assets/icons/main/bi_check-square.svg";
import { ReactComponent as TickIcon } from "../assets/icons/main/Vector.svg";
import { get } from "lodash";
import { useTheme } from '@mui/material';
import { palette } from "../theme/palette";
import lightOrdarkColor from "@check-light-or-dark/color";

const Styles = {
  checkedIcon: {
    fontSize: "0.8rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
};

export default function CheckboxComponent(props: any) {
  const [checked, setChecked] = useState(false);
  const themeData: any = useTheme();

  const handleCheckboxChange = (event: any) => {
    setChecked(event.target.checked);
  };

  return (
    <div>
      <Checkbox
        name={props.name}
        checked={props.checked}
        disabled={props.disabled}
        onChange={props.handleCheckboxChange}
        inputProps={{ 'aria-label': 'controlled' }}
        sx={props.style}
        icon={
          <>
            {!props.disabled ? (
              <CheckBoxIcon style={{ fontSize: "1.2rem", color: themeData.palette.primary.main }} />
            ) : (
              <CheckBoxIcon style={{ fontSize: "1.2rem", color: lightOrdarkColor(themeData.palette.background.default) === 'dark' ? palette.disabledColor.dark : palette.disabledColor.light, }} />
            )}
          </>
        }
        indeterminate={props.indeterminate}
        checkedIcon={
          <div style={{ display: "flex", alignItems: "center" }}>
            {!props.disabled ? (
              <>
                <CheckBoxIcon
                  style={{
                    fontSize: "1.2rem",
                    backgroundColor: themeData.palette.primary.main,
                    borderRadius: "2px",
                    borderColor: themeData.palette.primary.main,
                  }}
                />
                <TickIcon
                  style={{ ...Styles.checkedIcon, position: "absolute", color: palette.primary.contrastText }}
                />
              </>
            ) : (
              <>
                <CheckBoxIcon
                  style={{
                    fontSize: "1.2rem",
                    borderRadius: "2px",
                    borderColor: lightOrdarkColor(themeData.palette.background.default) === 'dark' ? palette.disabledColor.dark : palette.disabledColor.light,
                    backgroundColor: lightOrdarkColor(themeData.palette.background.default) === 'dark' ? palette.disabledColor.dark : palette.disabledColor.light,
                  }}
                />
                <TickIcon
                  style={{ ...Styles.checkedIcon, position: "absolute", color: palette.disabledColor.contrastText }}
                />
              </>
            )}
          </div>
        }
      />
    </div>
  );
}
